import React, { useState, useEffect } from 'react';

const ThinkingLabel = () => {
  const [thinkingPhase, setThinkingPhase] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setThinkingPhase((prev) => (prev + 1) % 4);
    }, 500);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const thinkingText = ['Thinking', 'Thinking.', 'Thinking..', 'Thinking...'][thinkingPhase];

  return (
    <div className="flex items-center justify-start p-3 bg-transparent text-sm text-gray-500 dark:text-gray-400">
      {thinkingText}
    </div>
  );
};

export default ThinkingLabel;